import ISection from "./ISection";
import NanoPopup from "../../../components/Popups/NanoPopup";
import { TInformationPageTranslation } from "../../../Support/Types/TInformationPageTranslation";

export default class UserAgreementSection
  extends NanoPopup
  implements ISection
{
  constructor() {
    super({ target: ".information-page-popup" });
  }

  public static get isPresent(): boolean {
    return $(".information-page-popup").length > 0;
  }

  private _translation?: TInformationPageTranslation = null;

  public get translation(): TInformationPageTranslation {
    return this._translation;
  }

  public set translation(value: TInformationPageTranslation) {
    this._translation = value;
  }

  private _onChange: () => void;

  public get onChange(): () => void {
    return this._onChange;
  }

  public set onChange(callback: () => void) {
    this._onChange = callback;
  }

  public get isValid(): boolean {
    return this._translation !== null;
  }

  public CheckValidity(): void {}

  public Show(): void {
    const mainTitle = $(".info-page-title");
    const mainContent = $(".info-page-content");
    mainTitle.text(this._translation.name);
    mainContent.html(
      `${this._translation.popup_content ?? ""}\n${
        this._translation.common_content
      }`,
    );
    super.Show();
  }
}
